import React, { Component } from "react";
import { Link } from "react-router-dom";

//Components
import NavbarGroup from "../components/navbarGroup";
import NotificationTypeTable from "../components/notificationTypeTable";
import SearchBox from "../components/common/searchBox";

//Other
import _ from "lodash";
import { ToastContainer, Zoom } from "react-toastify";
import { ArrowLeftCircle, PlusCircle } from "react-bootstrap-icons";

//Services
import httpService from "./../services/httpService.js";
import config from "../config.json";

class pageNotificationTypes extends React.Component {
  state = {
    currentPage: 1,
    dataRetreived: [],
    groupName: "",
    groupID: "",
    pageSize: 8,
    raceNameYear: "",
    raceID: "",
    searchQuery: "",
    sortColumn: { path: "name", order: "asc" },
  };

  async componentDidMount() {
    const groupName = localStorage.getItem("groupName");
    const groupID = localStorage.getItem("groupID");
    const raceNameYear = localStorage.getItem("raceNameYear");
    const raceID = localStorage.getItem("raceID");
    const userTypeID = localStorage.getItem("userTypeID");

    this.setState({
      groupName,
      groupID,
      raceNameYear,
      raceID,
    });

    // Get notification Types by race ID
    let { data: Dbdata } = await httpService.get(
      config.apiEndpointNotificationTypesGet + "?raceID=" + raceID
    );
    this.setState({ dataRetreived: Dbdata });

    // Set the back button address for each user type
    let goToPage = "/";
    if (userTypeID === "3") goToPage = `pageRaceHome/${raceID}`;
    if (userTypeID === "4") goToPage = `pageRaceEntityHome/${raceID}`;

    this.setState({ goToPage });
  }

  handleSort = (sortColumn) => {
    this.setState({ sortColumn: sortColumn });
  };

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      currentPage: 1,
    });
  };

  handlePageIncrement = (sentCurrentPage, pagesCount) => {
    if (sentCurrentPage < pagesCount) {
      sentCurrentPage++;
      this.setState({ currentPage: sentCurrentPage });
    }
  };

  handlePageDecrement = (sentCurrentPage) => {
    if (sentCurrentPage != 1) {
      sentCurrentPage--;
      this.setState({ currentPage: sentCurrentPage });
    }
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  render() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    let {
      currentPage,
      dataRetreived,
      goToPage,
      pageSize,
      raceNameYear,
      raceID,
      searchQuery,
      sortColumn,
    } = this.state;

    const sortedData = _.orderBy(
      dataRetreived,
      [sortColumn.path],
      [sortColumn.order]
    );

    // filter the data from search input contents
    let filtered = sortedData;
    if (searchQuery)
      filtered = sortedData.filter((m) =>
        m.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );

    const allentriesTotal = filtered.length;

    return (
      <React.Fragment>
        <ToastContainer
          draggable={true}
          transition={Zoom}
          autoClose={2000}
          position="top-center"
        />
        <NavbarGroup />

        <div className="container container-top-70">
          <div className="row">
            <h5>{raceNameYear} - Notification Types</h5>
            <div className="col" data-aos="fade-right">
              <span className="button-padding">
                <Link to={`/${goToPage}`} className="btn p-0">
                  <ArrowLeftCircle color="#002072" size={40} />
                </Link>

                <Link to="/notificationTypeForm/new" className="btn p-0">
                  <PlusCircle color="#002072" size={40} />
                </Link>
              </span>
            </div>
            <div className=" col searchBar-width-300" data-aos="fade-left">
              <SearchBox
                value={searchQuery}
                onChange={this.handleSearch}
                placeholder="Search Types..."
              />
            </div>
          </div>

          <div className="row">
            <div
              className="col table-top-padding"
              data-aos="zoom-in"
              data-aos-duration="5000"
            >
              <NotificationTypeTable
                allentriesTotal={allentriesTotal}
                currentPage={currentPage}
                filteredRaceUsers={filtered}
                onPageDecrement={this.handlePageDecrement}
                onPageIncrement={this.handlePageIncrement}
                onPageChange={this.handlePageChange}
                onSort={this.handleSort}
                pageSize={pageSize}
                sortColumn={sortColumn}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default pageNotificationTypes;
